import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { UseFormReset } from 'react-hook-form';

import { getUserProfile } from '../api';
import { setUserProfile } from '../store';

import { UserProfileForm } from './use-user-profile.form';

type UseGetUserProps = {
  reset: UseFormReset<UserProfileForm>;
};

export const useGetUserProfile = ({ reset }: UseGetUserProps) => {
  const userProfileQuery = useQuery({
    queryKey: ['userProfile'],
    queryFn: getUserProfile,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    if (
      userProfileQuery.isError ||
      userProfileQuery.isFetched === false ||
      userProfileQuery.data === undefined
    )
      return;
    if (userProfileQuery.isSuccess) setUserProfile(userProfileQuery.data);
    reset(userProfileQuery.data);
  }, [
    userProfileQuery.isError,
    userProfileQuery.isFetched,
    userProfileQuery.isSuccess,
    userProfileQuery.data,
    reset,
  ]);

  return userProfileQuery;
};
